import styled from '@emotion/styled'

export const YousignIframe = styled.iframe<{ height?: string }>`
  width: 100%;
  height: ${({ height }) => height || '100%'};
  border: none;
`
